import { StrictMode } from 'react';
import App from '@/app/App.tsx';
import { createRoot } from 'react-dom/client';
import './polyfills';

const importRegion = async () => {
    try {
        const url = import.meta.env.DEV ? 'http://localhost:3090' : window.location.origin;
        const { Region } = await import(`${url}/region-front/index.js`);

        Region.header.mount();
        Region.footer.mount();
    } catch (e: unknown) {
        if (e instanceof Error) {
            console.log(e.message);
        }
    }
};

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>
);

importRegion();
